import { render, staticRenderFns } from "./Collect1.vue?vue&type=template&id=40051c06&scoped=true&lang=pug&"
import script from "./Collect1.vue?vue&type=script&lang=ts&"
export * from "./Collect1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40051c06",
  null
  
)

export default component.exports